"use server";

import { signIn } from "@/lib/auth";
import { AuthError } from "next-auth";

export interface SignInResult {
  ok: boolean;
  error?: string;
}

// Magic-link sign-in. Always returns ok:true on non-exception paths to avoid
// account enumeration — the email is only actually sent for known users
// (see signIn callback in src/lib/auth.ts).
export async function signInAction(formData: FormData): Promise<SignInResult> {
  const emailRaw = formData.get("email");
  if (typeof emailRaw !== "string" || !emailRaw.includes("@")) {
    return { ok: false, error: "Please enter a valid email address." };
  }
  const email = emailRaw.trim().toLowerCase();

  try {
    await signIn("resend", {
      email,
      redirect: false,
      redirectTo: "/",
    });
    return { ok: true };
  } catch (err) {
    if (err instanceof AuthError) {
      // AccessDenied fires when our signIn callback returned false (unknown email).
      // Respond identically so callers cannot distinguish.
      if (err.type === "AccessDenied") return { ok: true };
      return { ok: false, error: "Could not send sign-in link. Please try again." };
    }
    throw err;
  }
}
